import RawSharedBasic from "./RawSharedBasic";
import { ModalProp } from "@/types";

const EcovacsOrderRequestDataInfo: ModalProp[] = [
  {
    key: "docNum",
    label: "Doc Num",
  },
  {
    key: "docType",
    label: "Doc Type",
  },
  {
    key: "docEntry",
    label: "Doc Entry",
  },
  {
    key: "orderType",
    label: "Order Type",
  },
  {
    key: "stockType",
    label: "Stock Type",
  },
  {
    key: "userRemark",
    label: "User Remark",
  },
  {
    key: "customerCode",
    label: "Customer Code",
  },
  {
    key: "warehouseCode",
    label: "Warehouse Code",
  },
  {
    key: "customerNumber",
    label: "Customer Number",
  },
  {
    key: "shippingMethod",
    label: "Shipping Method",
  },
  {
    key: "amazonReferNumber",
    label: "Amazon Refer Number",
  },
  {
    key: "isCustomerDeliver",
    label: "Is Customer Deliver",
  },
  {
    key: "amazonFreightNumber",
    label: "Amazon Freight Number",
  },
];

interface EcovacsOrderRequestRawProps {
  rawData: Record<string, unknown>;
  className?: string;
  labelStyle?: React.CSSProperties;
  contentStyle?: React.CSSProperties;
}

export const EcovacsOrderRequestRaw = (props: EcovacsOrderRequestRawProps) => {
  const { rawData, className, labelStyle, contentStyle } = props;
  return (
    <RawSharedBasic
      rawData={rawData}
      dataProps={EcovacsOrderRequestDataInfo}
      className={className}
      labelStyle={labelStyle}
      contentStyle={contentStyle}
    />
  );
};
